module.exports = __webpack_public_path__ + "img/down.c74e389c.svg";